import {getFirstFailedValidationMessage, type ValidationRule} from "@/main/validation/requirements";
import {REQUEST_VALIDATION_LIMITS, USERNAME_PATTERN} from "@/main/validation/request";

export const MODERATION_VALIDATION_LIMITS = {
    reasonMaxLength: REQUEST_VALIDATION_LIMITS.longText.maxLength,
    resolutionNoteMaxLength: 4000,
    warningSupplementMaxLength: 500,
} as const;

export type ModerationValidationMessages = {
    invalidUsername: string;
    requiredReason: string;
    reasonTooLong: string;
};

function createModerationUsernameValidationRules(message: string): ValidationRule[] {
    return [
        {
            id: "username",
            text: message,
            validate: (value: string) => {
                const trimmedValue = value.trim();
                return trimmedValue.length >= REQUEST_VALIDATION_LIMITS.username.minLength
                    && trimmedValue.length <= REQUEST_VALIDATION_LIMITS.username.maxLength
                    && USERNAME_PATTERN.test(trimmedValue);
            },
        },
    ];
}

function createModerationReasonValidationRules(
    messages: ModerationValidationMessages,
    reasonOptional: boolean
): ValidationRule[] {
    const rules: ValidationRule[] = [];
    if (!reasonOptional) {
        rules.push({
            id: "required",
            text: messages.requiredReason,
            validate: (value: string) => value.trim().length > 0,
        });
    }
    rules.push({
        id: "max",
        text: messages.reasonTooLong,
        validate: (value: string) => value.trim().length <= MODERATION_VALIDATION_LIMITS.reasonMaxLength,
    });
    return rules;
}

export function validateModerationForm(
    values: {username: string; reason: string},
    messages: ModerationValidationMessages,
    options?: {reasonOptional?: boolean}
) {
    return getFirstFailedValidationMessage(
        createModerationUsernameValidationRules(messages.invalidUsername),
        values.username
    ) ?? getFirstFailedValidationMessage(
        createModerationReasonValidationRules(messages, options?.reasonOptional ?? false),
        values.reason
    );
}
